import React from "react"
import { Box } from "@mui/material"
import useStyles, { CalendarTimeBoxStyles, CalendarTimeMonthStyles, CalendarTimeStyles } from "./styles/VisitorStyles"

function CalendarTimeIcon({ dateObj }) {

    const dayOfMonth = dateObj.getDate()
    const month = dateObj
        .toLocaleString("default", { month: "short" })
        .toUpperCase()
    const time = dateObj.toLocaleTimeString([], {
        timeStyle: "short"
    })

    return (
        <Box sx={CalendarTimeBoxStyles}>
            <Box sx={CalendarTimeMonthStyles}>
                {month + " " + dayOfMonth}
            </Box>
            <Box sx={CalendarTimeStyles}>{time}</Box>
        </Box>
    )
}

export default CalendarTimeIcon
